<template>
  <notice-form @save="handleAddSubmit" />
</template>

<script>
import NoticeForm from "@/components/notice-form/NoticeForm";
import {request} from "@/config/request";
export default {
  name: "NoticeAdd",
  components: {NoticeForm},
  data() {
    return {
    }
  },
  methods: {
    async handleAddSubmit(data) {
      try {
        await request(this.$api.notice.add, data);
        this.$message.success(this.$t('操作成功'));
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

.el-form {
  max-width: 700px;
}

</style>
